import { SpeakableSpeechMark } from '../tts.constants';
import { resetSpeechMarks } from './tts-reset-speech-marks';

export function adjustPausedSpeechMarks({
  speakableSpeechMarks,
  lastPlayedMarkTime,
  sourceSpeechMarks,
}: {
  speakableSpeechMarks: SpeakableSpeechMark[];
  lastPlayedMarkTime: number;
  sourceSpeechMarks: SpeakableSpeechMark[] | undefined;
}) {
  const unplayedSpeechMarks = resetSpeechMarks(sourceSpeechMarks).map(
    (speechMark, index) => {
      if (speakableSpeechMarks[index].played) {
        return {
          ...speechMark,
          played: true,
          indexInHtmlBody: speakableSpeechMarks[index].indexInHtmlBody,
          time: 0,
        };
      } else {
        return {
          ...speechMark,
          played: false,
          indexInHtmlBody: speakableSpeechMarks[index].indexInHtmlBody,
          time: speechMark.time - lastPlayedMarkTime,
        };
      }
    }
  );

  return unplayedSpeechMarks || [];
}
